import moment from 'moment-timezone'


type Day = {
  day: string
  format: string
}

type Range = {
  from: string | null
  to: string | null
  format: string
}

export function addDayToRange(
  { day, format }: Day,
  { from, to, format: rangeFormat }: Range,
  resultFormat: string,
) {
  const mDay = moment(day, format)
  let mFrom = from ? moment(from, rangeFormat) : null
  let mTo = to ? moment(to, rangeFormat) : null

  if (!mFrom) {
    mFrom = mDay
    // } else if (mFrom && mTo && mFrom.isSame(mTo, 'day') && mDay.isSame(mFrom, 'day')) {
    //   mFrom = null
    //   mTo = null
  } else if (mTo && mDay.isBefore(mFrom, 'day')) {
    mFrom = mDay
  } else if (mTo && mDay.isSame(mTo, 'day')) {
    mFrom = mDay
    mTo = mDay
  } else {
    mTo = mDay
    if (mTo.isBefore(mFrom)) {
      mTo = mFrom
      mFrom = mDay
    }
  }

  return {
    from: mFrom ? mFrom.format(resultFormat) : null,
    to: mTo ? mTo.format(resultFormat) : null,
  }
}
